var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.blocks),function(block){return _c('div',{staticClass:"mb-2"},[(block.blockType === 'text')?_c('block-viewer',{key:block.key,attrs:{"side":_vm.side,"block":block}}):_c('img',{key:block.key,staticClass:"block mx-auto",staticStyle:{"max-height":"50vh"},attrs:{"src":block.content}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }